/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isspeakerenabledbydefault4Inputs */

const en_entity_isspeakerenabledbydefault4 = /** @type {(inputs: Entity_Isspeakerenabledbydefault4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Speaker Enabled By Default`)
};

const de_entity_isspeakerenabledbydefault4 = /** @type {(inputs: Entity_Isspeakerenabledbydefault4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecher standardmäßig aktiviert`)
};

/**
* | output |
* | --- |
* | "Is Speaker Enabled By Default" |
*
* @param {Entity_Isspeakerenabledbydefault4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isspeakerenabledbydefault4 = /** @type {((inputs?: Entity_Isspeakerenabledbydefault4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isspeakerenabledbydefault4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isspeakerenabledbydefault4(inputs)
	return de_entity_isspeakerenabledbydefault4(inputs)
});
export { entity_isspeakerenabledbydefault4 as "entity_isSpeakerEnabledByDefault" }